module.exports = __webpack_public_path__ + "static/img/game_head.af569c8c.png";